import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { LanguageSelectBoxComponent } from './language-select-box/language-select-box.component';
import { DxSelectBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
  declarations: [LanguageSelectBoxComponent],
  imports: [CommonModule, DxSelectBoxModule, DxTextBoxModule, TranslocoModule, NgOptimizedImage],
  exports: [LanguageSelectBoxComponent],
})
export class LanguageSelectModule {}
